import { Theme } from '@mui/material'

const useSharedStyles = {
  introText: (theme: Theme) => ({
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  }),
  submitButton: (theme: Theme) => ({
    width: 'auto',
    minWidth: '65%',
    [theme.breakpoints.up('sm')]: {
      minWidth: '250px',
    },
  }),
  input: (theme: Theme) => ({
    [theme.breakpoints.up('sm')]: {
      maxWidth: '350px',
    },
  }),
  errorText: (theme: Theme) => ({
    color: theme.palette.error.main,
    fontSize: '14px',
  }),
  linkButton: {
    fontWeight: 'normal',
    textTransform: 'none',
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  },
  fullWidthContainer: {
    width: 'calc(100% + 32px)',
    marginLeft: '-16px',
    marginRight: '-16px',
  },
  divider: (theme: Theme) => ({
    color: theme.palette.divider,
    width: 'calc(100% + 32px)',
    marginLeft: '-16px',
    marginRight: '-16px',
  }),
}

export default useSharedStyles
